module.exports = __webpack_public_path__ + "img/1551766888.cbd60d80.jpg";